<h2 style="font-size: 32px !important;" mat-dialog-title>{{contenuto.titolo}}</h2>
<mat-dialog-content class="mat-typography">
  <h3>{{contenuto.testo}}</h3>
  <h4 *ngIf="contenuto.testo2 && contenuto.testo2.length > 0 " style="font-weight: bold">{{contenuto.testo2}}</h4>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button class="btn btn-grey" *ngIf="contenuto.hasCancel" mat-dialog-close>Annulla</button>
  <button  class="btn btn-primary" *ngIf="!contenuto.hasLoading" [mat-dialog-close]="true" (click)="actionOk()" cdkFocusInitial>Ok</button>
</mat-dialog-actions>
